function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.149.74a.6.6 0 01.6.6V6.4h5.06a.6.6 0 110 1.2H7.75v5.06a.6.6 0 11-1.2 0V7.6H1.49a.6.6 0 010-1.2h5.06V1.34a.6.6 0 01.6-.6z",
  fill: "#333"
});

function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjE0OTA1IDAuNzM5NzQ2QzcuNDgwNDIgMC43Mzk3NDYgNy43NDkwNSAxLjAwODM4IDcuNzQ5MDUgMS4zMzk3NVY2LjQwMDEySDEyLjgwOTRDMTMuMTQwOCA2LjQwMDEyIDEzLjQwOTQgNi42Njg3NSAxMy40MDk0IDcuMDAwMTJDMTMuNDA5NCA3LjMzMTQ5IDEzLjE0MDggNy42MDAxMiAxMi44MDk0IDcuNjAwMTJINy43NDkwNVYxMi42NjA1QzcuNzQ5MDUgMTIuOTkxOSA3LjQ4MDQyIDEzLjI2MDUgNy4xNDkwNSAxMy4yNjA1QzYuODE3NjggMTMuMjYwNSA2LjU0OTA1IDEyLjk5MTkgNi41NDkwNSAxMi42NjA1VjcuNjAwMTJIMS40ODg2N0MxLjE1NzMgNy42MDAxMiAwLjg4ODY3MiA3LjMzMTQ5IDAuODg4NjcyIDcuMDAwMTJDMC44ODg2NzIgNi42Njg3NSAxLjE1NzMgNi40MDAxMiAxLjQ4ODY3IDYuNDAwMTJINi41NDkwNVYxLjMzOTc1QzYuNTQ5MDUgMS4wMDgzOCA2LjgxNzY4IDAuNzM5NzQ2IDcuMTQ5MDUgMC43Mzk3NDZaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";
export { SvgIconPlus as ReactComponent };